// extracted by mini-css-extract-plugin
export default {"name":"change-password-by-admin_name__rmPbE","fields":"change-password-by-admin_fields__x+V86","field":"change-password-by-admin_field__pJziZ"};